import { createFileRoute } from '@tanstack/react-router'
import { ProfilDesa } from '../../../../components/ProfilDesa'

export const Route = createFileRoute('/platform/desa/$desaId/profil-desa')({
  component: () => {
    const { desaId } = Route.useParams()
    return <ProfilDesa desaId={desaId} />
  },
})
